
import { createI18n } from 'vue-i18n';
import messages from './messages.js';

const supportedLocales = Object.keys(messages);

const savedLocale = localStorage.getItem('locale');
const userLocale = navigator.language.split('-')[0];

let initialLocale = 'en';

if (savedLocale && supportedLocales.includes(savedLocale)) {
  initialLocale = savedLocale;
} else if (supportedLocales.includes(userLocale)) {
  initialLocale = userLocale;
}


const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: initialLocale, // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
  pluralizationRules: {
    'en': function (choice, choicesLength) {
      if (choicesLength === 1) {
        return 0;
      }
      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;
      if (!teen && endsWithOne) {
        return 0;
      }
      const endsWithTwo = choice % 10 === 2;
      if (!teen && endsWithTwo) {
        return 1;
      }
      const endsWithThree = choice % 10 === 3;
      if (!teen && endsWithThree) {
        return 2;
      }
      return 3;
    }
  }
});

export default i18n;
